var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/IconPiggyBank.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var IconPiggyBank = function IconPiggyBank(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    id: "Build_Layer",
    "data-name": "Build Layer",
    xmlns: "http://www.w3.org/2000/svg",
    width: "44",
    height: "44",
    viewBox: "0 0 44 44",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("title", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }, "Icon Piggy Bank"), /*#__PURE__*/React.createElement("path", {
    fill: "#a6e5ff",
    d: "M25.06,8.46a6.089,6.089,0,0,0-1.12,1.2.631.631,0,0,1-.52.27h-.91a13.983,13.983,0,0,0-5.63,1.18V9.9a1.35,1.35,0,0,0-2.7,0v1.34c-2.37.39-3.88,1.91-3.88,4.03a3.9,3.9,0,0,0,.22,1.35,12.62,12.62,0,0,0-1.11,2.24,1.156,1.156,0,0,1-.84-1.22v-.01a1.274,1.274,0,0,0-1.28-1.27A1.291,1.291,0,0,0,6,17.64a3.8,3.8,0,0,0,2.75,3.72,13.193,13.193,0,0,0-.18,2.02,13.41,13.41,0,0,0,2.05,7.18A13.489,13.489,0,1,1,25.06,8.46Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16.88,9.9v1.21a13.94,13.94,0,0,0-6.36,5.51,3.9,3.9,0,0,1-.22-1.35c0-2.12,1.51-3.64,3.88-4.03V9.9a1.35,1.35,0,0,1,2.7,0Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M36.48,20.21l-.69-1.46a11.021,11.021,0,0,0-3.1-3.9l-.98-.77V8.75a9.065,9.065,0,0,0-5.02,1.69A13.491,13.491,0,0,1,15.51,31.48c-.28,0-.56-.02-.83-.04a8.393,8.393,0,0,0,.63.56l.98.78v4.15h2.63a3.217,3.217,0,0,1,3.15-2.57h2.57a3.2,3.2,0,0,1,3.15,2.57h2.64V33.48l1.22-.76a11.168,11.168,0,0,0,1.63-1.22,3.887,3.887,0,0,1,2.59-1h3.56V20.21Zm-4.77,2.58a1.276,1.276,0,0,1-.72-.22.934.934,0,0,1-.18-.16,1,1,0,0,1-.16-.19,1.288,1.288,0,0,1,0-1.44,1,1,0,0,1,.16-.19,1.256,1.256,0,0,1,.4-.28,1.35,1.35,0,0,1,.5-.1,1.3,1.3,0,0,1,.91.38,1.244,1.244,0,0,1,.38.91A1.293,1.293,0,0,1,31.71,22.79Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6e5ff",
    d: "M17.57,21.5c-.25.6-.94.98-2.01.98a4.19,4.19,0,0,1-2.83-1.21,2.062,2.062,0,0,0-1.21-.6,11.144,11.144,0,0,1,.84-2.12,6.691,6.691,0,0,0,1.51.49l1.85.4a6.245,6.245,0,0,1,.63.17,3.935,3.935,0,0,0-.06.6,1.294,1.294,0,0,0,.37.91A1.278,1.278,0,0,0,17.57,21.5Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6e5ff",
    d: "M29,17.99A13.49,13.49,0,0,1,15.51,31.48c-.28,0-.56-.02-.83-.04a10.809,10.809,0,0,1-3.52-7.8,6.031,6.031,0,0,0,3.02,1.16v1.29a1.35,1.35,0,0,0,2.7,0V24.76c2.47-.45,4-1.99,4-4.18a3.614,3.614,0,0,0-.37-1.65H24a1.293,1.293,0,0,0,1.29-1.29,1.393,1.393,0,0,0-.1-.5,1.377,1.377,0,0,0-.28-.4.236.236,0,0,0-.09-.08,1.273,1.273,0,0,0-.56-.27,1.09,1.09,0,0,0-.26-.03H20.14a4.15,4.15,0,0,0-2.22.68,7.085,7.085,0,0,0-.73-.18l-1.85-.38a3.558,3.558,0,0,1-1.19-.42,11.08,11.08,0,0,1,2.79-2.14,4.354,4.354,0,0,1,1,.73,2.05,2.05,0,0,0,1.42.61,1.091,1.091,0,0,0,1.13-1.1,2.172,2.172,0,0,0-.58-1.36,11.707,11.707,0,0,1,2.6-.3h.91a3.2,3.2,0,0,0,2.61-1.35,3.86,3.86,0,0,1,.66-.71A13.417,13.417,0,0,1,29,17.99Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20.49,14.16a1.091,1.091,0,0,1-1.13,1.1,2.05,2.05,0,0,1-1.42-.61,4.354,4.354,0,0,0-1-.73,11.529,11.529,0,0,1,2.97-1.12A2.172,2.172,0,0,1,20.49,14.16Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M17.92,17.04a3.5,3.5,0,0,0-1.57,2.57,6.245,6.245,0,0,0-.63-.17l-1.85-.4a6.691,6.691,0,0,1-1.51-.49,10.714,10.714,0,0,1,1.79-2.49,3.558,3.558,0,0,0,1.19.42l1.85.38A7.085,7.085,0,0,1,17.92,17.04Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20.88,20.58c0,2.19-1.53,3.73-4,4.18v1.33a1.35,1.35,0,0,1-2.7,0V24.8a6.031,6.031,0,0,1-3.02-1.16,2.286,2.286,0,0,1-.02-.25,11.09,11.09,0,0,1,.38-2.72,2.062,2.062,0,0,1,1.21.6,4.19,4.19,0,0,0,2.83,1.21c1.07,0,1.76-.38,2.01-.98a1.293,1.293,0,0,0,1.29-1.29,1.827,1.827,0,0,1,.03-.35,1.37,1.37,0,0,1,.07-.24.052.052,0,0,1,.02-.04v-.01a1.071,1.071,0,0,1,.13-.21.912.912,0,0,1,.17-.17.817.817,0,0,1,.2-.12.681.681,0,0,1,.24-.08.647.647,0,0,1,.2-.04,1.635,1.635,0,0,1,.22-.02h.37A3.614,3.614,0,0,1,20.88,20.58Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0d4599",
    d: "M39.43,17.64H38.12a13.8,13.8,0,0,0-3.83-4.81V6.71a.649.649,0,0,0-.63-.64h-.02c-2.05.03-6.03.27-8.58,2.39a6.089,6.089,0,0,0-1.12,1.2.631.631,0,0,1-.52.27h-.91a14.131,14.131,0,0,0-11.99,6.69,12.62,12.62,0,0,0-1.11,2.24,1.156,1.156,0,0,1-.84-1.22v-.01a1.274,1.274,0,0,0-1.28-1.27A1.291,1.291,0,0,0,6,17.64a3.8,3.8,0,0,0,2.75,3.72,13.193,13.193,0,0,0-.18,2.02,13.41,13.41,0,0,0,2.05,7.18,13.616,13.616,0,0,0,3.09,3.46v4.19A1.293,1.293,0,0,0,15,39.5h5.14a1.293,1.293,0,0,0,1.29-1.29v-.64a.632.632,0,0,1,.64-.64h2.57a.64.64,0,0,1,.65.64v.64a1.285,1.285,0,0,0,1.28,1.29h5.14A1.293,1.293,0,0,0,33,38.21v-3.3a13.471,13.471,0,0,0,2.01-1.5,1.291,1.291,0,0,1,.86-.34h3.56A2.582,2.582,0,0,0,42,30.5V20.21A2.582,2.582,0,0,0,39.43,17.64Zm0,12.86H35.87a3.887,3.887,0,0,0-2.59,1,11.168,11.168,0,0,1-1.63,1.22l-1.22.76v3.45H27.79a3.2,3.2,0,0,0-3.15-2.57H22.07a3.217,3.217,0,0,0-3.15,2.57H16.29V32.78L15.31,32a8.393,8.393,0,0,1-.63-.56,10.809,10.809,0,0,1-3.52-7.8,2.286,2.286,0,0,1-.02-.25,10.567,10.567,0,0,1,1.22-4.84,10.714,10.714,0,0,1,1.79-2.49,11.08,11.08,0,0,1,2.79-2.14,11.529,11.529,0,0,1,2.97-1.12,11.707,11.707,0,0,1,2.6-.3h.91a3.2,3.2,0,0,0,2.61-1.35,3.86,3.86,0,0,1,.66-.71,9.065,9.065,0,0,1,5.02-1.69v5.33l.98.77a11.021,11.021,0,0,1,3.1,3.9l.69,1.46h2.95Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2a619",
    d: "M31.714,22.786A1.286,1.286,0,1,0,30.429,21.5,1.29,1.29,0,0,0,31.714,22.786Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2a619",
    d: "M31.714,20.214A1.285,1.285,0,0,0,30.429,21.5,1.289,1.289,0,0,1,31.714,20.214Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2a619",
    d: "M31.714,22.786A1.289,1.289,0,0,1,30.429,21.5,1.285,1.285,0,0,0,31.714,22.786Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2a619",
    d: "M31.714,22.786A1.286,1.286,0,0,0,33,21.5,1.29,1.29,0,0,1,31.714,22.786Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2a619",
    d: "M33,21.5a1.286,1.286,0,0,0-1.286-1.286A1.29,1.29,0,0,1,33,21.5Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0d4599",
    d: "M25.29,17.64A1.293,1.293,0,0,1,24,18.93H20.14a.82.82,0,0,0-.22.02.711.711,0,0,0-.2.04.681.681,0,0,0-.24.08.817.817,0,0,0-.2.12.685.685,0,0,0-.17.17,1.071,1.071,0,0,0-.13.21v.01a.052.052,0,0,0-.02.04,1.37,1.37,0,0,0-.07.24,1.827,1.827,0,0,0-.03.35,1.293,1.293,0,0,1-1.29,1.29,1.278,1.278,0,0,1-.91-.38,1.294,1.294,0,0,1-.37-.91,3.935,3.935,0,0,1,.06-.6,3.5,3.5,0,0,1,1.57-2.57,4.15,4.15,0,0,1,2.22-.68H24a1.09,1.09,0,0,1,.26.03,1.273,1.273,0,0,1,.56.27.647.647,0,0,1,.09.08,1.377,1.377,0,0,1,.28.4A1.393,1.393,0,0,1,25.29,17.64Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0d4599",
    points: "17.571 21.5 17.575 21.499 17.575 21.499 17.571 21.5",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0d4599",
    d: "M18.96,19.62a.052.052,0,0,1,.02-.04,1.024,1.024,0,0,0-.09.28A1.37,1.37,0,0,1,18.96,19.62Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 9
    }
  }));
};

IconPiggyBank.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
IconPiggyBank.defaultProps = {
  className: null
};
export default IconPiggyBank;